var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M359.3 368.5H152.7C141.2 368.5 131.9 377.6 131.9 388.9C131.9 400.2 141.2 409.3 152.7 409.3H359.3C370.8 409.3 380.1 400.2 380.1 388.9C380.1 377.6 370.8 368.5 359.3 368.5Z",
    fill: "#062134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M359.3 280.1H152.7C141.2 280.1 131.9 289.2 131.9 300.5C131.9 311.8 141.2 320.9 152.7 320.9H359.3C370.8 320.9 380.1 311.8 380.1 300.5C380.1 289.2 370.8 280.1 359.3 280.1Z",
    fill: "#062134"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M359.3 191.8H152.7C141.2 191.8 131.9 200.9 131.9 212.2C131.9 223.5 141.2 232.6 152.7 232.6H359.3C370.8 232.6 380.1 223.5 380.1 212.2C380.1 200.9 370.8 191.8 359.3 191.8Z",
    fill: "#062134"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6 460.2V51.8H297V136.4C297 141.8 299.2 147 303.1 150.8C307 154.6 312.3 156.8 317.8 156.8H414.4V460.2H97.6V460.2ZM338.6 77.6L381.5 115.9H338.6V77.6ZM449.2 121.3L331.8 16.3C328 12.9 323 11 317.8 11H76.8C65.3 11 56 20.1 56 31.4V480.6C56 491.9 65.3 501 76.8 501H435.2C446.7 501 456 491.9 456 480.6V136.4C456 130.6 453.5 125.2 449.2 121.3V121.3Z",
    fill: "#062134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFile);
export default __webpack_public_path__ + "static/media/ico_file.49d5aca0004ede46aeef1f0adc038f73.svg";
export { ForwardRef as ReactComponent };